export const getGtmInstructionsStyles = (_, { palette = {} }) => ({
  gtmInstructionsRoot: {
    '& .blocker-image': {
      width: '28px',
      height: '28px',
      border: '2px solid',
      animation: 'spinner 1s linear infinite',
      marginRight: '9px',
      borderRadius: '50%',
      borderTopColor: palette.themeLight,
      borderLeftColor: palette.themePrimary,
      borderRightColor: palette.themeLight,
      borderBottomColor: palette.themeLight,
    },
    '& .blocker-text': {
      color: palette.themePrimary,
    },
  },
  container: {
    fontSize: '14px',
    marginBottom: 12,
  },
  contentBlock: {
    marginBottom: 30,
    '& .btn-link': {
      color: '#0078d4',
      '&:focus, &:hover, &:active': {
        textDecoration: 'underline',
      },
    },
  },
  textBlock: {
    maxWidth: 1046,
  },
  imageCenterBlock: {
    minWidth: 140,
    width: '20%',
    margin: 'auto',
  },
  dropdown: {
    maxWidth: 350,
  },
  titleBlock: {},
  saveBar: {
    marginLeft: -8,
    '& button': {
      marginLeft: 8,
    },
  },
  statusActive: {
    paddingLeft: '6px',
    paddingBottom: '2px',
    font: 'bold 12px arial !important',
    color: '#333333 !important',
  },
  statusInactive: {
    paddingLeft: '6px',
    paddingBottom: '2px',
    font: 'normal 12px arial !important',
    color: '#b3b3b3 !important',
  },
  statusItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
  },
  bigCheck: {
    fontSize: 'medium',
    color: '#0078d4',
  },
  progressList: {},
});
